import {Component, HostBinding, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {TransportInterventionsPageRequest} from '../transport-interventions-page/transport-interventions-page-request';
import {TransportInterventionsNavigationActivatedComponent} from '../transport-interventions-navigation/transport-interventions-navigation-activated-component';
import {Subscription} from 'rxjs';
import DataSource from 'devextreme/data/data_source';
import PivotGridDataSource from 'devextreme/ui/pivot_grid/data_source';
import ArrayStore from 'devextreme/data/array_store';
import {DxPivotGridComponent} from 'devextreme-angular';

@Component({
  selector: 'app-transport-interventions-pivot-grid',
  templateUrl: './transport-interventions-pivot-grid.component.html',
  styleUrls: ['./transport-interventions-pivot-grid.component.scss']
})
export class TransportInterventionsPivotGridComponent extends TransportInterventionsNavigationActivatedComponent implements OnInit, OnChanges, OnDestroy {

  @Input()
  request: TransportInterventionsPageRequest;

  @Input()
  width: number;

  @Input()
  height: number;

  @Input()
  @HostBinding('hidden')
  hidden: boolean;
  private submitSub: Subscription;
  private hasPendingRequest: boolean;

  ds: DataSource;
  dataSource: PivotGridDataSource;
  store: ArrayStore;
  @ViewChild(DxPivotGridComponent, {static: false})
  pivotGrid: DxPivotGridComponent;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.submitSub = this.request.submit$.subscribe(() => {
      if (this.isActivated)  {
        this.loadRequest();
      } else {
        this.hasPendingRequest = true;
      }
    });
  }

  private loadRequest() {

    this.hasPendingRequest = false;
  }

  onActivated() {
    if (this.hasPendingRequest) {
      this.loadRequest();
    }
  }

  onDeactivated() {
  }

  ngOnDestroy(): void {
    this.submitSub.unsubscribe();
  }
}
